import { StatusCodes } from 'http-status-codes';
import React from 'react';
import { Redirect, withRouter, Link } from 'react-router-dom';
import { AuthenticationContext } from '../contexts/Authentication';
import HttpStatusError from '../errors/HttpStatusError';
import NotAuthenticatedError from '../errors/NotAuthenticatedError';

import { baseUrl } from 'Constants';

class ErrorBoundary extends React.Component {
  static contextType = AuthenticationContext;

  constructor(props) {
    super(props);

    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.setState({ error: null });
    }
  }

  render() {

    const error = this.state.error;

    if (error === null) {
      return this.props.children;
    }

    const authContext = this.context;

    const unauthorized = error instanceof NotAuthenticatedError || (error instanceof HttpStatusError && error.httpStatus === StatusCodes.UNAUTHORIZED);

    if (unauthorized) {
      authContext.reset();
      window.location = baseUrl + '/login';
      return;
    }

    return unauthorized ?
      <Redirect to="/login" /> : <>
        Odottamaton virhe. <Link to="/login">Siirry etusivulle</Link>
      </>;

  }
};

export default withRouter(ErrorBoundary);
